module.exports = {
      id: "googleplay-usage",
      viewBox: "0 0 135 40",
      url: __webpack_public_path__ + "svg-sprite-9780240c1c89505db7f372dec3b5867e.svg#googleplay",
      toString: function () {
        return this.url;
      }
    }